<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  ><g
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-miterlimit="10"
    stroke-width="1.5"
    clip-path="url(#a)"
  ><path d="M14.625 16.781c0-1.125-.844-1.968-1.969-1.968-2.625 0-3.656-1.876-4.125-3.376-.281-1.03-1.219-1.78-2.25-1.78-.75 0-1.406.655-1.406 1.405v2.813c0 2.625 2.156 4.781 4.781 4.781h3.188c1.031-.093 1.781-.937 1.781-1.875ZM9.844 8.438a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75ZM10.5 9.75l4.125-2.156c.656-.375 1.5-.094 1.875.562s.094 1.5-.563 1.875l-2.718 1.406c1.406 1.22 3.187-.374 5.719 1.97a1.45 1.45 0 0 1 .093 1.968c-.281.281-.656.469-1.031.469-.375 0-.656-.094-.938-.375" /><path d="M12 22.547c5.825 0 10.547-4.722 10.547-10.547S17.825 1.453 12 1.453 1.453 6.175 1.453 12 6.175 22.547 12 22.547Z" /></g><defs><clipPath id="a"><path
    fill="#fff"
    d="M0 0h24v24H0z"
  /></clipPath></defs></svg>
</template>
